import React from "react";

interface ListCountProps {
  episodeTotal: number;
  likeCount: number;
  ratingAvg: number;
}

const ListCount: React.FC<ListCountProps> = ({ episodeTotal, likeCount, ratingAvg }) => {
  return (
    <div className="list-count w-full py-2 md:py-4">
      <ul className="flex justify-center gap-3 md:gap-12 text-xs md:text-base">
        <li className="flex items-center gap-1">
          <img src="/assets/episode.svg" alt="Episode" className="w-4 h-4 md:w-auto md:h-auto" />
          <span>{episodeTotal || 0} Chương</span>
        </li>
        <li className="flex items-center gap-1">
          <img src="/assets/like.svg" alt="Like" className="w-4 h-4 md:w-auto md:h-auto" />
          <span>{likeCount || 0} Lượt thích</span>
        </li>
        <li className="flex items-center gap-1">
          <img src="/assets/rating.svg" alt="Rating" className="w-4 h-4 md:w-auto md:h-auto" />
          <span>{ratingAvg?.toFixed(1) || 0}/10</span>
        </li>
      </ul>
    </div>
  );
};

export default ListCount;
